import { STORE_LAST_VIEW } from 'actions/type'

export const storeLastView = payload => dispatch => {
  dispatch({
    payload: payload,
    type: STORE_LAST_VIEW
  })
}